import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
    import { THGCO2Equivalent } from '@/interfaces/thg/THGCO2Equivalent';
    import { fetchTHGCO2Equivalents } from '@/api/thg/co2_equivalents';
    import emitter from '@/utils/mitt';
    import GenericTHGCO2EquivalentTable from '@/components/thg/co2_equivalents/GenericTHGCO2EquivalentTable.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGCO2EquivalentsList',
  setup(__props) {

    const data = ref<THGCO2Equivalent[]>();

    async function doDataFetching() {
        emitter.emit('showLoader');
        data.value = (await fetch()) as THGCO2Equivalent[];
        emitter.emit('hideLoader');
    }

    async function fetch() {
        const response = await fetchTHGCO2Equivalents();
        const equivalents = await response.parsedBody;

        if (equivalents) {
            return equivalents;
        } else {
            throw new Error('Error while getting thg equivalents.');
        }
    }

    onMounted(async () => {
        await doDataFetching();
    });

return { __sfc: true,data, doDataFetching, fetch, GenericTHGCO2EquivalentTable }
}

})